export default{sources:{avif:"__VITE_ASSET__BxrInvJC__ 400w",webp:"__VITE_ASSET__BBPI9wqY__ 400w"},img:{src:"__VITE_ASSET__CbALgkXk__",w:400,h:267}};